import { useEffect, useState } from "react";

import { refreshAccessToken } from "../../Services/ApiRequest";
import {
  hasAccessToken,
  stripTokensFromUserProfile,
} from "../../Services/SessionStore";
import {
  getFromLocalStorage,
  saveToLocalStorage,
  STORAGE_KEYS,
} from "../../Utils/Helper/LocalStorage";

interface SessionBootstrapProps {
  children: React.ReactNode;
}

/**
 * Rehydrates in-memory access token from HttpOnly refresh cookie on page load
 * and migrates legacy localStorage entries that still contain tokens.
 */
const SessionBootstrap: React.FC<SessionBootstrapProps> = ({ children }) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const bootstrap = async () => {
      const profile = getFromLocalStorage(STORAGE_KEYS.LOGGED_IN_USER);

      if (profile && (profile.accessToken || profile.refreshToken)) {
        saveToLocalStorage(
          STORAGE_KEYS.LOGGED_IN_USER,
          stripTokensFromUserProfile(profile)
        );
      }

      if (!hasAccessToken() && profile) {
        try {
          await refreshAccessToken({ redirectOnFailure: false });
        } catch {
          // No valid refresh session; user will be sent to login on next API call.
        }
      }

      if (!cancelled) {
        setReady(true);
      }
    };

    bootstrap();

    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready) {
    return null;
  }

  return <>{children}</>;
};

export default SessionBootstrap;
